export default {
  home: "Home",
  aboutUs: "Chi siamo",
  capabilities: "Capacità",
  esg: "Sostenibilità",
  careers: "Carriere",
  contact: "Contatto",
  ourJourney: "Il nostro viaggio",
  visionMission: "Visione e missione",
  leadershipTeam: "Team di leadership",
};

